
<ng-container *transloco="let t; read: 'common'">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">Listado de recursos</h4>
        <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="resources" style="margin-top: 1.5rem;" class="row">
            <div class="col col-12 mx-auto">
              <app-resources-list [resources]="resources"  #resourceList ></app-resources-list>
            </div>
        
          </div>
    
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.close('cancel')">{{t('cancel')}}</button>
      </div>
    </ng-container>